import { atom, selector, selectorFamily } from 'recoil'

export const recipientState = atom({
  key: 'recipientsBounceRecipientState',
  default: {
    recipientProfile: {},
    channel: '',
  },
})

export const tableStateSerach = atom({
  key: 'recipientsBounceTableStateSerach',
  default: {
    orderBy: 'BounceOrderbyDate',
    orderDescending: false,
    pageSize: 10,
    pageNumber: 1,
  },
})

export const tableStateResult = atom({
  key: 'recipientsBounceTableStateResult',
  default: {
    items: [],
    totalItems: 0,
    status: 'initial',
    loading: false,
  },
})

export const resultsStateEmptyState = selector({
  key: 'recipientsBounceEmptyState',
  get: ({ get }) => {
    const { totalItems, status } = get(tableStateResult)

    return status === 'ready' && totalItems === 0
  },
})

export const selectedResultsState = atom({
  key: 'bounceListSelectedResultsState',
  default: [],
})

export const selectedResultsStateAllSelected = selector({
  key: 'bounceListSelectedResultsStateAllSelected',
  get: ({ get }) => {
    const selectedIds = get(selectedResultsState)
    const resultsIds = get(tableStateResult).items.map((item) => item.FakeId)

    return resultsIds.every((id) => selectedIds.includes(id))
  },
  set: ({ set, get, reset }, val) => {
    const resultsIds = get(tableStateResult).items.map((item) => item.FakeId)
    val
      ? set(selectedResultsState, (prev) => [
          ...prev,
          ...resultsIds.filter((f) => !prev.includes(f)),
        ])
      : set(selectedResultsState, (prev) =>
          prev.filter((f) => !resultsIds.includes(f)),
        )
  },
})

export const selectedResultsStateById = selectorFamily({
  key: 'bounceselectedResultsStateById',
  get:
    (idMessage) =>
    ({ get }) =>
      get(selectedResultsState).includes(idMessage),
  set:
    (idMessage) =>
    ({ get, set }, val) => {
      const selectedIds = get(selectedResultsState)
      if (val && selectedIds.includes(idMessage)) {
        return
      }
      val
        ? set(selectedResultsState, [...selectedIds, idMessage])
        : set(
            selectedResultsState,
            selectedIds.filter((id) => id !== idMessage),
          )
    },
})
